import { apiClient } from "helpers/api_helper";

export const getRepairProductBySearch = async (searchText: string) => {
    try {
        const response = await apiClient.get(`/api/v1/Repair/GetSearchRepairProductDetails?SearchText=${searchText}`);
        return response?.data || [];
    } catch (error: any) {
        throw new Error(error.message);
    }
};


export const getCustomerById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/customer/GetCustomerDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const getRepairReasonList = async () => {
    try {
        const response = await apiClient.get(`/api/v1/Repair/GetRepairWorkSelectList`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
}

export const createRepairProductEntry = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/Repair/InsertProductRepairWork`, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
}
export const createRepairProductOnEditEntry = async (data: any) => {
    try {
        const response = await apiClient.post(`/api/v1/Repair/CloseRepairBagProductStatus`, data);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
}

export const getCustomerCreditAmountById = async (cid: any) => {
    try { 
        const response = await apiClient.get(`/api/v1/Store/GetCustomerSalesEntryDetails?CustomerId=${cid}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
}